<template>
  <div>
    <template v-if="file?.urls?.regular">
      <div
        class="group aspect-h-7 aspect-w-10 relative block w-full overflow-hidden rounded-lg border-2 border-transparent bg-gray-100 hover:border-primary"
        :class="{'border-primary opacity-75': isSelected}">
        <blur-hash
          :hash="file.blur_hash"
          :src="file.urls.regular"
          :alt="file.description"
          class="aspect-h-7 aspect-w-10" />
        <div class="absolute h-1/2 bg-gradient-to-b from-black to-transparent opacity-75" />
        <div class="group m-2 shrink-0">
          <div class="flex items-center">
            <div>
              <img
                class="inline-block h-6 w-6 rounded-full"
                :src="file.user.profile_image.small"
                alt="">
            </div>
            <div class="ml-3">
              <p class="text-xs font-medium text-gray-300 group-hover:text-gray-100">
                {{ file.user.first_name }} {{ file.user.last_name }}
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="isSelected"
          class="absolute inset-0">
          <svg
            class="absolute right-1 top-1 h-5 w-5 text-primary"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <button
          type="button"
          class="absolute inset-0 focus:outline-none">
          <span class="sr-only">Select {{ file.name }}</span>
        </button>
      </div>
      <p class="pointer-events-none mt-1.5 block truncate text-xs font-medium text-font-dark">
        {{ file.description }}
      </p>
      <p class="pointer-events-none block text-xs font-medium text-font-light">
        {{ file.width }} x {{ file.height }} px
      </p>
    </template>
    <template v-else>
      <div
        class="group text-sm p-4 relative block w-full overflow-hidden rounded-lg border-2 border-gray-200 bg-gray-100 hover:border-primary"
        :class="{'border-primary opacity-75': isSelected}">
        Image could not load properly, probably because of Unsplash request limiting. Please try a refresh.
        <br><br>
        If the problem persists, please try again in a few minutes.
      </div>
    </template>
  </div>
</template>

<script setup>

import FormattedSize from '@/ComponentsDeprecated/FormattedSize.vue';
import BlurHash from '@/ComponentsDeprecated/BlurHash.vue';

const props = defineProps({
  file: {
    type: Object,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});
</script>
